import { db } from '../plugins/firebase.js';

const collecionName = 'live_reports';
export const getAll = async function() {
	const ref = db.collection(collecionName).orderBy('date', 'desc');

	const snap = await ref.get().then((s) => {
		return s;
	});

	let res = [];
	snap.forEach((doc) => {
		res.push({
			postId: doc.data().postId,
			date: doc.data().date,
			title: doc.data().title,
			content: doc.data().content,
		});
	});
	return res;
};

export const getOne = async function(postId) {
	const ref = db.collection(collecionName).doc(postId);

	return await ref.get().then((doc) => {
		if (!doc.exists) {
			return null;
		} else {
			return doc.data();
		}
	});
};
